module.exports = __webpack_public_path__ + "img/dtx-banner-2.96bcf491.png";